import { createTheme } from "@material-ui/core/styles";

const createLightTheme = (direction = "ltr") =>
	createTheme({
		direction,
		palette: {
			primary: {
				light: "#9c343e",
				main: "#9c343e",
				dark: "#9c343e",
				contrastText: "#000000",
			},
			secondary: {
				light: "#444444",
				main: "#444444",
				dark: "#444444",
				contrastText: "#ffffff",
			},
		},
		typography: {
			fontFamily:
				direction === "rtl"
					? '"Cairo", "Tahoma", "Arial", sans-serif'
					: '"Helvetica", "Arial", "Sahabah", "Tahoma", sans-serif',
		},
		overrides: {
			MuiCssBaseline: {
				"@global": {
					body: {
						direction,
						backgroundColor: "#ffffff",
					},
				},
			},
		},
	});

export default createLightTheme;
